import { render, staticRenderFns } from "./Rankings.vue?vue&type=template&id=6b9f36c0&"
import script from "./Rankings.vue?vue&type=script&lang=js&"
export * from "./Rankings.vue?vue&type=script&lang=js&"
import style0 from "./Rankings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports